import { useQuery } from '@tanstack/react-query'
import { getMessageTrends, type MessageTrend } from '@/services/dashboardApi'
import { queryKeys } from '@/lib/queryKeys'
import { useAuthStore } from '@/store/authStore'

/** Serie diaria de mensajes para la línea del KPI. Sin refresco propio. */
export function useMessageTrends(days: number = 7) {
  const tenantId = useAuthStore((state) => state.tenantId)

  return useQuery<MessageTrend[]>({
    queryKey: queryKeys.dashboardTrends(tenantId, days),
    queryFn: () => getMessageTrends(days),
    enabled: Boolean(tenantId),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
